<app-header *ngIf="comSvc.username" class="noise-header"></app-header>
<app-spinner [isLoadingResults$]="isLoading$" [loaderMessage$]="loaderMessage$"></app-spinner>
<div class="wrapper">
  <div class="contentArea" [ngClass]="comSvc.username ? 'margin-top45rem' : ''">
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer></app-footer>
